import classNames from "classnames";
import "./index.scss";

interface IProps {
  theme?: "light" | "dark";
  style?: string;
  onClick?: () => void;
  color?: string;
}

export const CloseIcon = ({ color, theme, style, onClick }: IProps) => {
  return (
    <div
      className={classNames({
        "close-icon-container": true,
        [`${style}`]: style,
      })}
      onClick={onClick}
    >
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.83333 0.5L0 3.33333L5.66667 9L0 14.6667L2.83333 17.5L8.5 11.8333L14.1667 17.5L17 14.6667L11.3333 9L17 3.33333L14.1667 0.5L8.5 6.16667L2.83333 0.5Z"
          fill={color ? color : theme === "light" ? "white" : "black"}
        />
      </svg>
    </div>
  );
};
